/**
 * The UapHeader component is designed specifically with links provided by the
 * UAP token, which contains two sets of links. One is displayed under a
 * collapsable menu, and the other set is displayed alongside user specific
 * information.
 */
import React from 'react';
import Animate from './Animate';
import Button from './Button';
import MainNavMenu from './MainNavMenu';
import AccountInfoMenu from './AccountInfoMenu';
import Map from './NweaMapLogo';
import HamburgerMenuIcon from './HamburgerMenuIcon';
import CloseMenuIcon from './CloseMenuIcon';
import styles from './AppHeader.module.css';

const UapHeader = ({ headerMenus, onToggleShowMenu, showMenu, username, title }) => {
  const Icon = showMenu ? CloseMenuIcon : HamburgerMenuIcon;
  return (
    <header data-testid="app-header">
      <div className={styles['pageHeader']}>
        <div className={styles['menu']}>
          <Button
            titleText="Main Navigation"
            buttonDataId="main-navigation-menu"
            className={styles['mainNavMenuToggle']}
            onClick={(e) => onToggleShowMenu(!showMenu, e)}
            ariaLabel="Main Navigation"
            ariaExpanded={showMenu}
          >
            <Icon dataTestId={showMenu ? 'primaryMenu-close-icon' : 'primaryMenu-open-icon'} />
          </Button>
          <Animate animate={showMenu} className={styles['mainMenuHide']} animateClass={styles['mainMenuShow']}>
            <div className={styles['menuAnimateContainer']}>
              <MainNavMenu menuItems={headerMenus.primaryMenuItems} />
            </div>
          </Animate>
        </div>
        <div className={styles['logo']}>
          <Map dataTestId="nwea-map-logo" />
        </div>
        <h1 style={{ fontWeight: '400' }} className={`${styles['appTitle']} nwea-ds-v1-typography-heading-2`}>
          {title}
        </h1>
        <div className={styles['spacer']}>
          <div />
        </div>
        <div className={styles['accountInfo']}>
          <div className={styles['headerUserAccount']}>
            Logged in as{' '}
            <span data-id="account-user-name" className={styles['userNameStyle']}>
              {username}
            </span>
          </div>
          <AccountInfoMenu menuItems={headerMenus.secondaryMenuItems} />
        </div>
      </div>
    </header>
  );
};

UapHeader.defaultProps = {
  title: undefined,
};

export default UapHeader;
